
import { string, object } from 'yup';

const schema = object().shape({
  indications: string().required('requiredField'),
  reference: string().required('requiredField'),
  declared_value: string().required('requiredField').matches(/^[0-9]+$/, 'onlyNumbers'),
  phone: string().nullable().notRequired().test('is-number', 'onlyNumbers', function(value) {
    if (!value || value === '') return true;
    return /^[0-9]+$/.test(value);
  }),
  email: string().nullable().notRequired().test('is-email', 'invalidEmailAddress', function(value) {
    if (!value || value === '') return true;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }),
  collected_value: string().nullable().notRequired().test('is-number', 'onlyNumbers', function(value) {
    if (!value || value === '') return true;
    return /^[0-9]+$/.test(value);
  })
});

export default schema;